import { get } from "api/Base.api";
import { IPagination } from "api/interfaces/common.interface";
import { IAgencyList } from "api/interfaces/app.interface";

// 기획사 목록 조회 응답 인터페이스
export interface IAgencyListResponse {
    agencyList: IAgencyList[];
    pagination?: IPagination;
}

/**
 * 기획사 목록 조회
 * @param page 페이지 번호 (기본값: 1)
 * @returns 기획사 목록
 */
export const getAgencyList = async (page: number = 1): Promise<IAgencyListResponse> => {
    const response = await get(`/student/v2/agency`, { page });
    return response;
};

